module.exports = __webpack_public_path__ + "img/mycell.b01185f7.jpg";